var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181857_165774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9999,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181857_165774)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9999,
    r: 12,
    fill: "url(#paint0_linear_181857_165774)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_181857_165774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9842 22.719L22.9883 15.2166C20.5629 12.6155 19.3502 11.315 17.9307 10.8285C16.6832 10.4009 15.3295 10.3963 14.0791 10.8152C12.6563 11.292 11.4347 12.5841 8.99138 15.1683L1.85254 22.719L16.0155 32.6654L29.9842 22.719Z",
    fill: "url(#paint1_linear_181857_165774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.959 15.2438L29.9238 22.7129L16.0154 32.6164L1.91339 22.7129L9.02045 15.1958C10.2426 13.9032 11.1575 12.9355 11.9446 12.2313C12.7314 11.5273 13.3878 11.0891 14.0918 10.8532C15.3339 10.437 16.6785 10.4416 17.9177 10.8663C18.6201 11.1071 19.2734 11.5498 20.0554 12.2592C20.8376 12.9689 21.7459 13.9428 22.959 15.2438Z",
    stroke: "url(#paint2_linear_181857_165774)",
    strokeWidth: 0.08
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8641 22.1472C7.21258 24.376 3.47749 19.7466 3.47749 16.7082C2.83814 18.7506 2.7015 24.6778 4.23595 27.7467C6.15402 31.5829 13.7197 30.6238 22.7773 30.6238C30.0233 30.6238 31.4782 29.2994 31.5138 24.6108C29.8088 24.4155 28.8601 20.1961 25.1189 18.0469C21.973 16.2397 17.9544 20.1398 12.8641 22.1472Z",
    fill: "url(#paint3_linear_181857_165774)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8312 20.4165C26.4827 22.6453 30.2178 18.0159 30.2178 14.9775C30.8572 17.0199 30.9938 22.9471 29.4594 26.016C27.5413 29.8521 19.9756 28.8931 10.918 28.8931C3.67198 28.8931 1.99868 26.8788 1.96316 22.1901C3.66811 21.9948 4.83525 18.4654 8.57639 16.3162C11.7223 14.509 15.7409 18.4091 20.8312 20.4165Z",
    fill: "url(#paint4_linear_181857_165774)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_181857_165774",
    x: -4.54746,
    y: 4.10439,
    width: 40.9318,
    height: 34.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_181857_165774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_181857_165774",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181857_165774",
    x1: 16,
    y1: 3.99994,
    x2: 16,
    y2: 17.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181857_165774",
    x1: 15.9184,
    y1: 10.5229,
    x2: 15.9184,
    y2: 27.7779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342439,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181857_165774",
    x1: 15.9184,
    y1: 12.4476,
    x2: 15.9184,
    y2: 21.7319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181857_165774",
    x1: 24.5757,
    y1: 17.8159,
    x2: 17.1845,
    y2: 30.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181857_165774",
    x1: 8.95442,
    y1: 16.0852,
    x2: 16.317,
    y2: 28.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0152D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5790EC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo32);
export default __webpack_public_path__ + "static/media/logo32.0c9709e3229213d2a28a36592c2c01ee.svg";
export { ForwardRef as ReactComponent };